import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from '@adsk/alloy-react-box';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const Header = _ref => {
  let {
    className,
    style,
    children,
    left,
    right
  } = _ref;
  return /*#__PURE__*/React.createElement(Flex, {
    className: className,
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    width: "100%",
    height: "48px",
    borderBottom: "1px solid ".concat(theme.colors.charcoal200),
    style: style
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    justifyContent: "start",
    flex: 1
  }, left), children, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, right));
};
Header.displayName = 'Header';
Header.propTypes = {
  /** Button's content */
  children: PropTypes.node,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Header left side render function */
  left: PropTypes.element,
  /** Header right side render function */
  right: PropTypes.element
};
export default Header;
//# sourceMappingURL=Header.js.map